export default function (value) {
  if (typeof (value) === 'string') {
    return value.replace(/[\u4E00-\u9FA5]/g, '')
  } else {
    return value
  }
}
